import { Component, OnInit, Input, ElementRef, ViewChild, OnDestroy, AfterViewInit, OnChanges, SimpleChanges,
  Output, EventEmitter } from '@angular/core';
import _ from 'lodash';

@Component({
  selector: 'app-edit-twodimension-virtualtour',
  templateUrl: './edit-twodimension-virtualtour.component.html',
  styleUrls: ['./edit-twodimension-virtualtour.component.scss']
})
export class EditTwodimensionVirtualtourComponent implements OnInit, OnDestroy, AfterViewInit, OnChanges {
  @Input() spaceData;
  @Input() mediaData;
  @Input() selectedMedia;
  @Input() enableEditShowcase;
  @ViewChild('rendererContainerEdit') rendererContainer: ElementRef;
  @Output() changeMediaEmit = new EventEmitter();

  animateId: any;

  linkDisplay =  false;
  infoDisplay =  false;
  toggle = false;
  loading = true;
  playIconClicked = true;
  fullScreen = false;
  // three js basic controls
  controls = null;
  renderer = null;
  scene = null;
  camera = null;
  ambientLight = null;
  pointLight = null;
  geometry = null;
  material = null;
  raycaster = new THREE.Raycaster();

  manualControl = false;

  // Canvas config
  CANVAS_HEIGHT = 850;
  CANVAS_WIDTH = 1200;
  CANVAS_CENTER_X = 0;
  CANVAS_CENTER_Y = 0;

  initialCameraPosition = { x: 2, y: -15, z: 9};

  imagesData = [];
  hotspotsData = [];
  sphereMesh = null;
  currentImage: any;

  // Hotspots
  hotspotsImage = new Image();
  hotspotsTexture = null;
  hotspotsMesh = [];

  mouse = new THREE.Vector2(0, 0);
  selectedMesh = null;
  INTERSECTED = [];
  normalMatrix = new THREE.Matrix3();
  worldNormal = new THREE.Vector3();
  lookAtVector = new THREE.Vector3();
  dragging = false;


  rotWorldMatrix = null;


  selectedMeshPosition = null;


  // Clicked position while creating hotspot
  clickedPosition: any;

  constructor() {
    this.scene = new THREE.Scene();
    this.renderer = new THREE.WebGLRenderer( { antialias: true } );

     // tslint:disable-next-line:max-line-length
    // this.hotspotsImage.src = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABHNCSVQICAgIfAhkiAAABV5JREFUaIHVms1vVFUYxp/nzNwLtaUqStqEURoTorggFBKhLV8NMcAMhJJI/AdMRA0s/IolYcNCTAzEVI1uXLkSE6EBpmFVoFOkQgVZlJgulDgNM0Kolg4D9+t1MdPSwj0zd6YzU3w27Z3znnN+77nvPffc9xyiApL+zQudzINNHlQHiWUQLhVKhMKlACCQJMExUMZEcEPBGwzXLzjHzrP359o3y4Y+s/EFx3H2eOBWghsBLCyxifsiOEfKGcPzjnHnz2PlcJTsgJxc87yt6g5CZC9Is5xOH29UsgL2mIpHGB24VUrVwA5I/+YGK2N/RPB9EA2lUwbpRO4KedR05Ah3Dd4NUiWQA9LX8bLl4gTJV+ZGGEwCjJhhawe3/vJHMduiDth9bVvEUz8BbKwMXkAJblOxy4gODBYyK+iAdbrjbQi/BhEK1KnRALV4Fdi4PHc99XdiNMc0MQrvzlXAngzUHEQskG+ZscT3OhOtA9bpjr0AvwkCHYpsBxa3QjVtCMTlpQeAO1fgJvsCOiPvmLHBb/1KfB2wT7W1C9VZgEahZlVkO0Ir9gNGmc+0PQn3eg+8ZF8RQ7FJ1ekXTo85IPG1EVuMXwEs0TXHxuUIrfkUrGsuHdoPL5uCO3wAkg81jW4ZtFczOpScxTKrod6ORXYY5wGu0rWiIlGEVuwrf9R1sifhXv8SXjJewEiuGE8Z7TPf4GpmsRXmB0XhV3ZXHh7IPUsru6Ei0QJGbLXuOZ/M+mXqH+ld22SHw78DfNqv6jR8DeReO6y/E4J/jAXZFr4+/C8w4w7Y4VC3Dp6Ny3NhUyOFVux7OBU/BoNnrAd13Q8vMTX6xp/QLMjCnT9W7IENKsmm4PTv0RRK1qD1EmOXUgoA7HB4NzTwKhKtOTwAsK5Z/zyQdTbMLiAfQiLs8jU0GmoaOo+q0Gw3xaykt2MRIZ2+DUSi1ZlxgspoyDH4iJBOubzGUFZIYtp1/eLWauIFk46BNJ103RYFKv8lstEA1bS+imTBpJrWa6PAA9YpirT4VnwSRj8vpZlSKdKiQPo6AN08PB/Sh1GLEkjt58gKSSDNioCvA/Mx9+ukYyHQrHxL/kdSAqT8CiTr+/O8SMciQEoRfHJISxTBlALE34HCX0e11Z0rmgLRO+BpK9VennYwJaVEcNG3zJ6El05UjyqgvHRCm7kQwUVlKjcOEcvX4km4CzoGEcusN08pRocmBOz3s3GTccDJVBOvsJxMjsFHAvaz8+ykAgBSTvha2ZNwR3qqB1hE7kiPNnymmBUAGCHVC4j4GXrJ+Ly8EySbKpBiETEc5ziQd4DbBm4KeEjXmDt8oLah5GRyfWok4CHuGkoDM7ISJu2jEEn7VpgYrWkouSM9BbJ08rfpyJGpq2kHGB2aAPCZrlEvGYd77XDlKDUqmBMCAMHhmZsfsxZzRr3xFSDndXWnnahGODmZAPCSyDE+lE9yd8MSy/Muk3xR1858JHcF+Mv0squ5c/j2LBY/Yyve1gpRQ8XT61GEXt0PhOvLAoeTgTvSUyShC0AkC0q7Gbtw9dGiCm1wRPMbHMGSAF46kd/giAfa4BDImwtig8f8ygJsMaEn8Haq0ZBLBuS/p6dCbPo9MjGaWySWssUEvGvuGPxOZxJgk6+9TVyeBPlcsF4rIwFuEthtxhJDheyCbbOebl9mg8cB1ibXIvKbQWsbY5eKLgECfRMzduGGkRlfR+JDCMbnTqiRYJyQj417468FgQfKOWpwav2zNuUgBO9V9KgB8YUp/Jw7EiUN0JwOe9iO+4YIt5LYhHIOe0DOK8iZsCc/1Oywh598j9tAlhKMAIBQxihMVuO4zX+boEvn6Da7LAAAAABJRU5ErkJggg==';
    this.hotspotsImage.src = 'assets/images/hotspot.png';
    this.hotspotsTexture = new THREE.Texture();
    this.hotspotsTexture.image = this.hotspotsImage;
    this.hotspotsImage.onload = () => {
      this.hotspotsTexture.needsUpdate = true;
    };

  }

  ngOnInit() {
  }

  infoButton() {
    this.infoDisplay = !this.infoDisplay;
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.selectedMedia && changes.selectedMedia.currentValue) {
      this.hotspotsData = changes.selectedMedia.currentValue.hotspot ? changes.selectedMedia.currentValue.hotspot : [];
      setTimeout(() => {
        this.createSphereAndHotspots();
      }, 1000);
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.init();
    }, 1000);
  }

  onMouseMove( event ) {
    this.manualControl = true;
    const canvasBounds = this.renderer.context.canvas.getBoundingClientRect();
    this.mouse.x = ( ( event.clientX - canvasBounds.left ) / ( canvasBounds.right - canvasBounds.left ) ) * 2 - 1;
    this.mouse.y = - ( ( event.clientY - canvasBounds.top ) / ( canvasBounds.bottom - canvasBounds.top) ) * 2 + 1;
  }

  onMouseDown(event) {
    this.manualControl = false;
  }

  onMouseUp(event) {
    if (!this.manualControl && event.target.nodeName === 'CANVAS') {
      this.raycaster.setFromCamera( this.mouse, this.camera );
      const intersects = this.raycaster.intersectObjects( [this.sphereMesh] );
      if ( intersects.length > 0 ) {
        this.clickedPosition = intersects[0].point;
        this.createNewHotspots();
      }
    }
  }

  createNewHotspots() {
    const ringGeometry = new THREE.CircleGeometry( 0.2, 128 );
    const ringMaterial = new THREE.MeshBasicMaterial( { map: this.hotspotsTexture, side: THREE.DoubleSide } );
    const ringMesh = new THREE.Mesh( ringGeometry, ringMaterial );
    ringMesh.name = 'new';
    ringMesh.position.set(this.clickedPosition.x + 1, this.clickedPosition.y, this.clickedPosition.z);
    this.hotspotsMesh.push(ringMesh);
    this.selectedMeshPosition = ringMesh.position;
    this.sphereMesh.add( ringMesh );
    this.linkDisplay = true;
  }

  getPositionFromMouse() {
    // Get the 3d position of mouse
    const vec = new THREE.Vector3(); // create once and reuse
    const pos = new THREE.Vector3(); // create once and reuse
    vec.set( this.mouse.x, this.mouse.y, 0.5);
    vec.unproject( this.camera );
    vec.sub( this.camera.position ).normalize();
    const distance = - this.camera.position.z / vec.z;
    pos.copy( this.camera.position ).add( vec.multiplyScalar( distance ) );
    return pos;
  }

  init() {

    this.CANVAS_WIDTH = Math.round(parseFloat(getComputedStyle(this.rendererContainer.nativeElement).width));
    this.CANVAS_HEIGHT = Math.round(parseFloat(getComputedStyle(this.rendererContainer.nativeElement).height));
    this.CANVAS_CENTER_X = this.CANVAS_WIDTH / 2;
    this.CANVAS_CENTER_Y = this.CANVAS_HEIGHT / 2;

    this.renderer.setPixelRatio( window.devicePixelRatio );
    this.renderer.setSize( this.CANVAS_WIDTH, this.CANVAS_HEIGHT );
    this.renderer.setClearColor('#0C7CA5', 0);

    this.rendererContainer.nativeElement.appendChild(this.renderer.domElement);

    // Web vr
    // this.renderer.vr.enabled = true;
    // this.rendererContainer.nativeElement.appendChild( WEBVR.createButton( this.renderer, { frameOfReferenceType: 'head-model' } ) );

    this.camera = new THREE.PerspectiveCamera( 75, window.innerWidth / window.innerHeight, 0.1, 1000 );
    this.camera.position.z = 0.01;

    this.controls = new THREE.OrbitControls( this.camera, this.renderer.domElement );
    this.controls.target = new THREE.Vector3(0, 0, 0);

    this.controls.enableZoom = false;
    this.controls.enablePan = false;
    this.controls.enableDamping = true;
    this.controls.rotateSpeed = - 0.1;

    // scene
    this.ambientLight = new THREE.AmbientLight( 0xcccccc, 0.4 );
    this.scene.add( this.ambientLight );
    this.pointLight = new THREE.PointLight( 0xffffff, 0.8 );
    this.camera.add( this.pointLight );
    this.scene.add( this.camera );

    // this.addHelper();
    this.animate();

    // this.rendererContainer.nativeElement.addEventListener('dblclick', this.doubleClickEvent.bind(this));

  }

  // Helper to show axis and camera axis
  addHelper() {
    const helper = new THREE.CameraHelper( this.camera );
    this.scene.add( helper );
    const axesHelper = new THREE.AxesHelper( 5 );
    this.scene.add( axesHelper );
  }

  createSphereAndHotspots() {

    const geometry = new THREE.SphereGeometry( 10, 60, 40 );
    // invert the geometry on the x-axis so that all of the faces point inward
    geometry.scale( - 1, 1, 1 );

    const texture = new THREE.TextureLoader().load( `${this.selectedMedia.url}` );
    const sphereMaterial = new THREE.MeshBasicMaterial({
      map: texture,
    });
    this.sphereMesh = new THREE.Mesh( geometry, sphereMaterial );
    this.sphereMesh.name = this.selectedMedia.uuid;
    this.sphereMesh.material.side =  THREE.DoubleSide;

    // this.sphereMesh.geometry.verticesNeedUpdate = true;
    // this.sphereMesh.geometry.computeFaceNormals();

    this.scene.add(this.sphereMesh);
    this.loading = false;
    // this.addMediaHotspot();
  }


  onProgressObjectLoader(xhr) {

  }

  onErrorObjectLoader(xhr) {

  }

  animate() {
    this.animateId = requestAnimationFrame(this.animate.bind(this));
    this.updateMetaTagsRotationOnMouseMove();
    this.controls.update();
    // TWEEN.update();
    this.render();
  }

  render() {
    if (this.renderer) {
      this.renderer.render( this.scene, this.camera );
      // this.renderer.setAnimationLoop( this.render );
    }
  }

  resizeHandler(event) {

    this.CANVAS_WIDTH = Math.round(parseFloat(getComputedStyle(this.rendererContainer.nativeElement).width));
    this.CANVAS_HEIGHT = Math.round(parseFloat(getComputedStyle(this.rendererContainer.nativeElement).height));

    this.camera.aspect = this.CANVAS_WIDTH / this.CANVAS_HEIGHT;
    this.camera.updateProjectionMatrix();
    this.renderer.setSize( this.CANVAS_WIDTH, this.CANVAS_HEIGHT );
  }

  onDocumentMouseWheel( event ) {
    // const fov = this.camera.fov + event.deltaY * 0.05;
    // this.camera.fov = THREE.Math.clamp( fov, 10, 75 );
    // this.camera.updateProjectionMatrix();
  }

  ngOnDestroy() {
    this.scene = null;
    this.camera = null;
    this.renderer = null;
  }

  toggleMenuEmit(response) {
    this.toggle = response;
  }

  changeMedia(response) {
    this.changeMediaEmit.emit(response);
  }

  linkHotspotButton() {
    this.linkDisplay = !this.linkDisplay;
    // if (this.linkDisplay) {
    //   this.createHotspots();
    // }
  }

  addMediaHotspot() {
    let i;
    for (i = 0; i < this.hotspotsData.length; i++) {
      const hotspots = this.hotspotsData[i];
      this.createMediaHotspot(hotspots);
    }
  }

  createMediaHotspot(hotspot) {
    const ringGeometry = new THREE.CircleBufferGeometry( 0.2, 128 );
    const ringMaterial = new THREE.MeshBasicMaterial( { map: this.hotspotsTexture, side: THREE.DoubleSide } );
    const ringMesh = new THREE.Mesh( ringGeometry, ringMaterial );
    ringMesh.position.set(hotspot.coordinates.x, hotspot.coordinates.y, hotspot.coordinates.z);
    this.hotspotsMesh.push(ringMesh);
    this.sphereMesh.add( ringMesh );
  }

  getCenterPoint(mesh) {
    const geometry = mesh.geometry;
    geometry.computeBoundingBox();
    const center = geometry.boundingBox.getCenter();
    mesh.localToWorld( center );
    return center;
}


  updateMetaTagsRotationOnMouseMove() {
    let i;
    for (i = 0; i < this.hotspotsMesh.length; i++) {
      const ringMesh = this.hotspotsMesh[i];
      if (this.camera) {
        ringMesh.lookAt( this.camera.position );
      }
    }
  }

  createHotspotEmit(response) {
    this.linkDisplay = !this.linkDisplay;
    this.selectedMedia.hotspot.push(response);
  }

  deleteHotspot() {

  }

  removeComponentProperties() {
    cancelAnimationFrame(this.animateId); // Stop the animation
    this.renderer.domElement.addEventListener('dblclick', null, false); // remove listener to render
    this.scene = null;
    this.camera = null;
    this.controls = null;
    this.empty(this.rendererContainer.nativeElement);
  }

  empty(elem) {
      while (elem.lastChild) {
        elem.removeChild(elem.lastChild);
      }
  }

}
